export default __webpack_public_path__ + "static/media/111-focus-theta-waves.bd40ee8e.jpeg";